import { Fragment, useEffect, useState } from 'react'
import OperateModal from './modal/OperateModal'
import Sidebar from './sidebar/Sidebar'
import Visualization from './visualization/Visualization'
import OperateService from '../../../service/OperateService'
import Loader from '../../../Layouts/Loader/Loader'
import { useNavigate, useParams } from "react-router-dom";
import ConfirmationDialog from '../../CommonComponents/confirmation_dialog/ConfirmationDialog'
import { toast } from 'react-toastify'
import { showToastMessage } from '../../../utils/commonFunctions'

const Operate = () => {

  const navigate = useNavigate();
  const params = useParams();
  const { mission_name, mission_id } = params
  const [sidebarLoader, setSidebarLoader] = useState(false)
  const [openModal, setOpenModal] = useState(false)
  const [loadingScreen, setLoadingScreen] = useState(true);
  const [delete_sat, set_delete_sat] = useState<any>(false)
  const [promotedSatellites, setPromotedSatellites] = useState([])

  const delete_promoted_satellite = (promotedId) => {
    setSidebarLoader(true)
    OperateService.deletePromoteSatellite(mission_id, promotedId)?.then((res) => {
      if (res.data) {
        get_all_promoted_satellites()
        showToastMessage('success', 'Satellite deleted successfully')
      }
    }).catch((err) => {
      console.error(err);
      setSidebarLoader(false)
      showToastMessage('error', 'Something went wrong while deleting satellite')
    })
  }

  const get_all_promoted_satellites = () => {
    if (!mission_id || mission_id === 'undefined') return;
    OperateService.getAllPromotedSatellites(mission_id)?.then((res) => {
      if (res.data) {
        setPromotedSatellites(res.data)
        setSidebarLoader(false)
      }
    }).catch((err) => {
      setSidebarLoader(false)
      console.error(err);
    })
  }

  const navigate_to_dashboard = (scenarioId: string, satelliteGroupId: string, satelliteId: string, trueTwinId: string) => {
    navigate(`${process.env.PUBLIC_URL}/${mission_name}/${mission_id}/operate/${scenarioId}/satGroupId/${satelliteGroupId}/satellite/${satelliteId}/hud`)
  };

  const calculate_orbit_details = (data: any) => {
    const scenarioId = data?.['scenarioId']
    const satelliteGroupId = data?.['groupId']
    const satelliteId = data?.['satId']
    const trueTwinId = data?.['trueTwinId']
    navigate_to_dashboard(scenarioId, satelliteGroupId, satelliteId, trueTwinId)
  }

  useEffect(() => {
    if (mission_id && mission_id !== 'undefined') {
      get_all_promoted_satellites()
    }
  }, [mission_id])


  return (
    <Fragment>
      <div className='w-100 d-flex align-items-center justify-content-center h-100 position-relative'>
        <Sidebar
          delete_sat={delete_sat}
          set_delete_sat={(data) => set_delete_sat(data)}
          sidebarLoader={sidebarLoader}
          setSidebarLoader={(data) => setSidebarLoader(data)}
          openModal={(data) => { setOpenModal(data) }}
          promotedSatellites={promotedSatellites}
          calculate_orbit_details={(data) => calculate_orbit_details(data)}
        />
        <Visualization
          promotedSatellites={promotedSatellites}
          setLoadingScreen={(data) => setLoadingScreen(data)}
        />
      </div>
      <ConfirmationDialog
        type='delete'
        open={delete_sat ? true : false}
        title={`Delete Satellite?`}
        description={`Deleting ${delete_sat?.['name']} will permanently remove it from the database, and it cannot be restored once deleted.`}
        onCancel={() => set_delete_sat(false)}
        onConfirm={() => {
          delete_promoted_satellite(delete_sat?.['trueTwinId'])
          set_delete_sat(false);
        }}
        confirm_button_text={`Delete`}
      />
      {openModal && <OperateModal
        close={() => {
          setOpenModal(false)
        }}
        navigate_to_operate={get_all_promoted_satellites}
        openModal={openModal}
      />}
      {loadingScreen && <Loader />}
    </Fragment >
  )
}

export default Operate